module.exports = __webpack_public_path__ + "static/shiallia-nobanion-savras-red_knight-sharess-DND3_FnP-3549c902ebcb117a6564a7253313ced7.webp";